export default "__VITE_ASSET__CH3a8rU3__"